// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MorePosts__posts":"pu_a bii_rc bii_qx bii_xr"};